const ImageVariant = {
    ORIGINAL: "",
    MEDIUM: "_medium",
    SMALL: "_small",
    THUMBNAIL: "_thumbnail"
}

export default ImageVariant;